import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { Box } from '@material-ui/core';
import { useLocation } from 'react-router';
import { hideRecoverPass, showRecoverPass } from '../../../redux/modules/loginBlock';
import RecoverPasswordDialog from '../../Dialogs/RecoverPasswordDialog';
import RecoverPasswordForm from '../../FormComponents/RecoverPasswordForm';
import useDeviceResize from '../../../hooks/useDeviceResize';
import { login, recoverPassword } from '../../../redux/modules/auth';

import EfesLogo from '../../../img/efesLogoDarkWithText.png';

import useStyles from '../makeStyles';

const RecoverPasswordWrapper = () => {
  const isDeviceLgSize = useDeviceResize('lg');
  const classes = useStyles();
  const dispatch = useDispatch();
  const { search } = useLocation();

  const urlParams = new URLSearchParams(search);
  const email = urlParams.get('email');
  const token = urlParams.get('token');

  const showRecoverPassword = useSelector((state) => state.loginBlock.showRecoverPassword);

  useEffect(() => {
    if (search === `?token=${token}&email=${email}`) {
      dispatch(showRecoverPass());
    }
  }, [search, email, token, dispatch]);

  const closeRecoverPassword = useCallback(() => {
    dispatch(hideRecoverPass());
  }, [dispatch]);

  const onSubmit = useCallback(
    (data) => {
      const userDetails = {
        password: data.newPassword,
        email,
        token,
      };
      dispatch(recoverPassword(userDetails)).then(() => {
        closeRecoverPassword();
        dispatch(login({ email, password: data.newPassword }));
      });
    },
    [dispatch, email, token, closeRecoverPassword],
  );

  if (isDeviceLgSize) {
    return (
      <BottomSheet
        open={showRecoverPassword}
        onDismiss={closeRecoverPassword}
        className={classes.root}
      >
        <Box p={2} pb={2}>
          <img src={EfesLogo} alt="logo" className={classes.logo} />
          <RecoverPasswordForm onSubmit={onSubmit} />
        </Box>
      </BottomSheet>
    );
  }

  return (
    <RecoverPasswordDialog
      open={showRecoverPassword}
      onClose={closeRecoverPassword}
      onSubmit={onSubmit}
    />
  );
};

export default RecoverPasswordWrapper;
